import * as React from 'react'
import { useCallback, useState } from 'react'
import DirectIntroductionForm from './direct_introduction_form'
import Company from 'entities/company'
import Group from 'entities/group'
import Offer from 'entities/offer'
import Recruiter from 'entities/recruiter'

type PrimitiveProps = {
  selectable: boolean
  deviceName: string
  contentId: number
  statuses: Array<Array<string | number>>
}

type OriginalProps = {
  company: Object
  offer: Object
  group: Object
  searchGroup: Group
  introducer: Object | null
} & PrimitiveProps

type ConvertedProps = {
  company: Company
  offer: Offer
  group: Group
  searchGroup: Group
  introducer: Recruiter | null
} & PrimitiveProps

const convertPropsToJsProps = (props: OriginalProps): ConvertedProps => {
  return {
    ...props,
    introducer: props.introducer ? new Recruiter(props.introducer) : null,
    company: new Company(props.company),
    offer: new Offer(props.offer),
    group: new Group(props.group),
    searchGroup: new Group(props.searchGroup)
  }
}

export const OpenDirectIntroductionModalButton: React.FC<OriginalProps> = props => {
  const [isOpen, setIsOpen] = useState(false)
  const openModal = useCallback(() => setIsOpen(true), [])
  const jsProps = convertPropsToJsProps(props)

  return (
    <>
      <button type="button" onClick={openModal}>
        {I18n.t('offers.pages.show.components.open_direct_introduction_modal_button.button')}
      </button>
      <DirectIntroductionForm {...jsProps} offer={props.offer} showModal={isOpen} onClose={() => setIsOpen(false)} />
    </>
  )
}
